<template>
  <div>
    <input type="file" accept="image/*" id="file" ref="file" v-on:change="handleFileUpload()" />
    <b-form-invalid-feedback :state="validated">{{error}}</b-form-invalid-feedback>
  </div>
</template>

<script>
import Axios from "axios";
import httpHelper from "../helpers/httpHelper";
export default {
  data() {
    return {
      file: "",
      //error:'فرمت فایل ارسالی اشتباه است'
      error: "",
      validated: true
    };
  },
  methods: {
    submitFile() {
      httpHelper.setAuth();
      httpHelper.UploadFile(this.file).then(res => {
        if (res.success) {
          this.validated = true;
          this.$emit("input", res.result);
        } else {
          this.error = res.error;
          this.validated = false;
        }
      });
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.submitFile();
    }
  }
};
</script>